<template>
  <div id="app">
    <header>
      <div class="collapse-menu-bg-wrapper">
          <div class="container">
            <div class="col-md-4 col-sm-5">
              <div class="nav-wrapper">
                <img src="./assets/site-logo.png" alt="logo">
              </div>
            </div>
          </div>
      </div>
    </header>    
    <div class="container">
      <section class="areas-section padding-55">
          <div class="container">
              <div class="col-lg-12 col-lg-offset-0 col-md-12 col-md-offset-0 col-sm-8 col-sm-offset-0 col-xs-12">
                  <h1 class="default-title mb-65">Gerador de QRcode</h1>
              </div>
              <div class="row">
                  <div class="col-lg-8 col-lg-offset-0 col-md-8 col-md-offset-0 col-sm-8 col-sm-offset-0 col-xs-12">
                    <form class="form-group">
                      <div class="form-group">
                        <label>Cole a URL:</label>
                        <input type="text" class="form-control" v-model.lazy="url">
                      </div>
                      <a-button type="primary" @click="gerar()" ghost><a-icon type="qrcode" />Gerar</a-button>
                    </form>
                    <h2>Como Inserir a imagem no seu arquivo Word</h2>
                    <iframe src="https://player.vimeo.com/video/416311909" width="640" height="480" 
                    frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                    <!-- <p class="text-justify">1. Clique no botão Iniciar do seu computador e digite CAP, 
                      depois abra a ferramenta de captura.</p>
                    <img class="imagem-tutorial" src="./assets/image/imagem1.png" alt="imagem1"> 
                    <p class="text-justify">2. Depois selecione "Novo".</p>
                    <img class="imagem-tutorial" src="./assets/image/imagem2.png" alt="imagem2">                    
                    <p class="text-justify">3. Após clicar em Novo vai aparecer um cursor para selecionar a área que voce deseja capturar,
                      então selecione o QRCode que foi gerado.</p>
                    <img class="imagem-tutorial" src="./assets/image/imagem3.png" alt="imagem3">                    
                    <p class="text-justify">4. Abra seu arquivo Word e aperte "CRTL + V" e depois ajuste a imgem conforme desejar.</p>
                    <img class="imagem-tutorial" src="./assets/image/imagem4.png" alt="imagem4">                     -->
                  </div>
                  <div class="col-lg-4 col-sm-4" v-if="value">
                    <qrcode-vue :value="value" :size="size" level="H"></qrcode-vue> 
                  </div>
              </div>
          </div>
      </section>
    </div>
    <footer class="footer">      
        <div class="container">
          <div class="col-lg-6 col-md-5 col-sm-8 col-xs-12">
            <span class="copyright">© 1990 - 2020 | Gaia Silva Gaede &amp; Associados - Sociedade de Advogados | 
              <a href="http://webmail.gsga.com.br" target="_blank" class="webmail">Webmail</a> | 
              <a href="http://espaider.gsga.net.br/espaider/" target="_blank" class="webmail">Espaider</a> | 
              <a href="https://gsga.com.br/suporte" target="_blank" class="webmail">Suporte</a></span>
          </div>					
        </div>      
    </footer>
  </div>  
</template>

<script>
import QrcodeVue from 'qrcode.vue';
export default {
  name: 'app',
  components: {
    QrcodeVue,
  },

  data () {
    return {
      url: '',
      value: '',
      size: 300,      
    }
  },

  methods: {
    gerar(){               
      this.value = this.url;      
    }
  }
}
</script>

<style lang="scss">
@import './assets/styles/variables';
@import './assets/styles/bootstrap';
.collapse-menu-bg-wrapper {
    background-color: #000;
    background-image: url('assets/logoligacao.png');
    background-repeat: no-repeat;
    background-position: 140% 30%;
    background-size: 60%;
    height: 85px;
}
.container {
    width: 1170px;
}

.nav-wrapper {
    position: absolute;
    top: 10px;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
}
body {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    font-size: 14px;
    line-height: 1.42857143;
    color: #333;
    background-color: #fff;
}
.padding-55 {
    padding: 55px 0;
}
.default-title {
    color: #143e3c;
    font-family: 'Lato', sans-serif;
    font-size: 18px;
    text-transform: uppercase;
    width: 100%;
    padding-bottom: 20px;
    position: relative;
}
.default-title.mb-65 {
    margin-bottom: 65px;
}

.btn-areas {
    color: #143e3c;
    border: solid 1px #143e3c;
    display: inline-block;
    font-family: 'Lato', sans-serif;
    /* font-size: 16px; */
    font-size: 18px;
    font-weight: 400;
    line-height: 38px;
    /* width: 160px; */
    width: 320px;
    max-width: 100%;
    height: 40px;
    margin: 15px 0 15px 0;
    text-align: center;
}
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: black;
  color: white;
  padding: 15px;
}
.copyright {
    color: #FFF;
    font-family: 'Calibri', sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 13px;
    display: inline-block;
}
.imagem-tutorial{
  width: 500px;
  height: 500px;
  padding: 15px;
}
</style>